
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Ini dibawakan oleh projek
                    <a href="${0}">Folksonomy Engine</a>. Jangan
                    teragak-agak untuk mengambil bahagian atau memberi maklum balas`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Alat ini membolehkan anda membetulkan senarai ramuan. Anda boleh menambah, mengalih keluar atau mengedit
                senarai ramuan.
                <br>
                Watak ini <span class="highlight">␣</span> mewakili ruang.
                <br>
                Watak ini <span class="highlight">↩︎</span> mewakili pemisah baris. `,
'hb28f1f2ec1744ee9': html`Sifat ini dicipta dan difailkan oleh pengguna untuk sebarang jenis penggunaan. Sila
                    bebas untuk menambah sendiri. Sifat dan nilai yang anda cipta
                    <strong>mestilah berfakta</strong>. Anda boleh menyelami
                    <a href="${0}">senarai sifat yang telah digunakan oleh komuniti</a>
                    atau terokai dokumentasi
                    <a href="${1}">dan enjin cariannya</a>.`,
's000a5b76bd3a01c2': `Memuatkan sifat...`,
's000d98595e959c1e': `Dapatkan Ia Di Google Play`,
's013bdc8cf0d3583d': `Bantu kami untuk bahan`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Sahkan tanaman`,
's03e9c8114521b998': `Saya akan mengedit bahan-bahan`,
's05ec315d9308091a': `Ikon sudut kod bar`,
's061eb5af92512c85': `Disimpan! Bolehkah anda membantu dengan yang lain?`,
's06847c221c4c0bc1': `Saya ingin mencipta harta untuk [menghuraikan kes penggunaan anda]...`,
's06f6c6f99db6b552': `Asal`,
's081e2ad82db71e1d': `Nilai Berkumpulan`,
's09205907b5b56cda': `Tidak`,
's0b4235aae602a950': `dokumentasi khusus`,
's0bb2d48532acc455': `Muat turun CSV`,
's0d5b7fee0311db68': `Hartanah`,
's0fb218abc2e157ed': `Imej tidak sah`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Batalkan pemangkasan`,
's11a18a69b30b65ed': `Bantu kami membetulkan ralat dalam senarai ramuan`,
's1205d5f6fccf8e69': `Nilai Harta`,
's15d64a0a6715285a': `Kunci baharu`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Kawasan pemilihan`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Bantu kami membetulkan maklumat pemakanan`,
's1e00019dc454872d': `Sila berikan nama hartanah menggunakan atribut property-name.`,
's1e49126af0935a5b': `Senarai produk yang menggunakan hartanah ini`,
's21e73088de6f26f3': `Muat turun di App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Dokumenkan harta itu`,
's300b3a6ee4e1252d': str`Padanan Kurang ${0}%`,
's33f786bb6b4f0cf4': `Hasil Tanaman`,
's33f85f24c0f5f008': `Simpan`,
's34be4af4e8fec4ae': `Tanya masyarakat dahulu`,
's36d86adc823cbfa6': `Sebelum mencipta harta baharu, bincangkannya dengan komuniti:`,
's3781d25aa51a736c': `Dokumentasi Enjin Folksonomy`,
's383ae4449428b61e': `Tetapkan semula pemangkasan`,
's39bcf88721a1e8ee': `Tetapkan semula pemilihan`,
's39e14e14300694c7': `Dokumentasi dan Garis Panduan`,
's3b430cfa5c1fe7f4': str`Dokumentasi untuk ${0}`,
's3f4e4b52f230a892': `Kanvas imej`,
's417b90913e05bc17': `Pratonton`,
's41f7dca46d3f1b4a': `Nilai`,
's422bba9636ce2489': `Imej tengah`,
's42dd66b2441566fd': `Ikon tengah`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Tambah nutrien`,
's453ab0dbb9b5c777': `Ubah saiz dengan betul`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Kiraan Produk`,
's4df2f533c0c1e7d0': `Kawalan imej`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Pindahkan pilihan`,
's4f751fb9b3ed766c': `Mencipta Hartanah Baharu`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Masukkan nama hartanah...`,
's55d7249883a98ca1': `tentang harta ini di wiki Fakta Makanan Terbuka`,
's565867d84c04aea2': `Penapis sifat...`,
's5666afe5cd0166de': `Sila betulkan ralat atau ubah suai teks sebelum mengesahkan`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Memuatkan produk...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Bantu kami membetulkan maklumat pemakanan.`,
's5dd6f12783fca34f': `Edit senarai ramuan`,
's5e8250fb85d64c23': `Tutup`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Terima kasih atas sumbangan anda!`,
's6cee7cad81dfedd1': `Imej Dipotong`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Padanan yang Baik ${0}%`,
's71a5c9f4b68ef4d4': `Bilang`,
's74cb3d66f6a668e1': `Dokumentasi`,
's787dd11bed0dc88a': `Ubah saiz ke kiri`,
's7ce4fd9430e80cea': `nilai`,
's801a05fa8e881f37': `Ketahui lebih lanjut tentang penciptaan hartanah dan garis panduan:`,
's8038273de2cf8b73': `Sila pilih kawasan untuk dipangkas.`,
's839cc2908a5387f2': `Tapis kod bar...`,
's86197dcf3e96af64': `Semak imbas dan cari sifat sedia ada`,
's8a63be30a129a59c': `Ubah saiz bahagian bawah`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Ubah saiz kanan atas`,
's8db84aa4bc949af2': `Dokumentasikan Harta Baharu`,
's8f839a03997a16d7': `Lihat Produk`,
's901ae1e236ac45d3': `Batalkan pemadaman`,
's907f7a97c6b29425': `Harap maklum bahawa model data mungkin diubah suai. Gunakan atas risiko anda sendiri.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `bahan-bahan:`,
's9a7f60fce090ecaf': `Gagal memuatkan sifat. Sila cuba lagi kemudian.`,
's9b87abd68fb9df45': `Tidak dijumpai? Cipta kunci baharu {value}`,
's9c0f52425fd2f07e': `Mungkin Tidak Padan`,
's9fc41f789c63b40d': `Produk`,
'sa1fa766e0d5634d7': `Tiada Skor Tersedia`,
'sa548778b24054030': `Terokai semua hartanah yang disumbangkan daripada projek Enjin Folksonomy. Sifat ini menyediakan metadata dan cerapan tambahan tentang produk dalam pangkalan data Fakta Makanan Terbuka.`,
'sa63907958bd0ec4b': `Ubah saiz kiri atas`,
'sa95b4224f685a36a': `Tutup modal`,
'sab56a1d439576fd6': `Ikon cadangan`,
'sac47ea2901d04c15': `Ubah saiz kiri bawah`,
'sb125227d436c2925': `Cari konsep hartanah anda dalam pangkalan data hartanah sedia ada:`,
'sb125568d43642e6f': `Jawab soalan tentang produk.`,
'sb1c538e038f9b214': str`Padanan yang Sangat Baik ${0}%`,
'sb28639570ff3b852': `senarai semua hartanah`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Setelah anda mengesahkan bahawa harta anda tidak wujud dan komuniti bersetuju ia berguna, anda perlu terlebih dahulu mendokumentasikannya dalam wiki.`,
'sb3d4f79d9d8b71e5': `Serahkan`,
'sb560fa37a7bfb6c2': `Tiada produk ditemui untuk hartanah ini.`,
'sb7f72e4c8a2d3357': `Nilai penapis...`,
'sb8178320160f84ea': `Tunjukkan tanaman`,
'sbad7d2734149470b': `Tentusahkan`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Semua pandangan telah dijawab! Terima kasih atas bantuan anda!`,
'sbd9a0b2293b3cd3c': `Saiz hidangan`,
'sbe472dc3c2685985': `Nilai Sepadan`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ubah saiz atas`,
'sc1c08d0cbcc3bd24': `Tidak Padan`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Pembaikan yang dicadangkan`,
'sc681b137e8f604f7': `Sahkan pemadaman`,
'sc6daf8a31883f8b9': `Gerakkan imej`,
'sc895972c88d38ca5': `Harta rakyat`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `baris`,
'scb3b0671d7b7f640': `Nilai baru`,
'scb489a1a173ac3f0': `Ya`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Sertai Slack Discussion`,
'scdb6cad0b92721bf': `Tiada hartanah ditemui.`,
'scf23a05631f93732': `Sahkan Padam`,
'scfed2f270ef6a3aa': `Pilih kawasan`,
'sd1022bc1ef9204f7': `Imej boleh dizum`,
'sd1077c055cf9ba6b': `Bantu kami mengesahkan senarai ramuan produk.`,
'sd698d21ddecba56b': `Hei! Anda boleh membantu kami menambah baik maklumat produk dengan menjawab bahagian berikut:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Semak sama ada harta sudah wujud`,
'sdbf806fefc584115': `Anda harus mencari a`,
'sdc673e73b5c13aea': `Padam`,
'sdc792b75f1edcaba': `Bantu kami membetulkan ejaan bahan.`,
'sdca5deead576ceee': `Ubah saiz kanan bawah`,
'sdcc2555c5dde524f': `Adakah anda pasti mahu memadamkan item ini? Tindakan ini tidak boleh dibuat asal.`,
'se206feec7ec57b28': `setiap 100g`,
'se419a9ab36987490': `Tidak sah`,
'se5127cf0f92e7e48': `Petua: anda juga boleh mencari`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Saya akan mencadangkan tanaman yang lebih baik`,
'seea3800e27baa686': `Produk Individu`,
'sefaba4adc4ec9219': `Sifat Folksonomi`,
'seffa8ca49175b5f0': `Harta yang diperibadikan`,
'sf44a6b3b232c28ea': str`Gantikan nilai semasa dengan ${0}`,
'sf4cd86a2f5ef2588': `Kod Bar Produk`,
'sf57a61152168cc81': `Bantu kami membetulkan pengesanan ramuan`,
'sf88b90b8ba23871c': `Perlawanan Tidak Diketahui`,
'sf9aee319a006c9b4': `Tambah`,
'sfacbbe968fa7d773': `Nama hartanah:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Nilai yang sepadan`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  